import { NgModule } from 'ng-metadata/core';

import 'jquery';
import 'moment';
import 'angular';
import 'angular-aria';
import 'angular-filter';
import 'angular-moment';
import 'angular-animate';
import 'angular-sanitize';
import 'angular-messages';
import 'angular-material';
import 'angular-datetime-input/dist/datetime';
import 'angular-material-expansion-panel';

import 'ng-mask';
import 'angular-ui-mask';
import 'ngstorage';
import 'slick-carousel';
import 'angular-sticky-plugin';
import 'angular-slick-carousel';

import { PipesModule } from './pipes';
import { ConfigModule } from './config/config.module';
import { CommonModule } from './common/common.module';
import { ServicesModule } from './services/services.module';
import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';

import './legacy/bugsnag.ts';
import './legacy/api-error-catcher.ts';

@NgModule({
  imports: [
    // https://github.com/candreoliveira/ngMask
    'ngMask',

    // https://github.com/angular-ui/ui-mask
    'ui.mask',

    // http://harm-less.github.io/angular-sticky/#!/
    'hl.sticky',

    // https://github.com/a8m/angular-filter
    'angular.filter',

    // https://github.com/eight04/angular-datetime
    'datetime',

    // https://docs.angularjs.org/api/ngSanitize/service/$sanitize
    'ngSanitize',

    // https://docs.angularjs.org/api/ngMessages/directive/ngMessages
    'ngMessages',

    // https://github.com/gsklee/ngStorage
    'ngStorage',

    // https://github.com/B-3PO/angular-material-expansion-panel
    'material.components.expansionPanels',

    // https://material.angularjs.org/latest/
    'ngMaterial',

    // https://docs.angularjs.org/api/ngAria
    'ngAria',

    // https://docs.angularjs.org/api/ngAnimate
    'ngAnimate',

    // https://github.com/urish/angular-moment
    'angularMoment',

    // Custom modules
    'controllers',
    'exceptionOverride',
    'ApiErrorCatcher',

    PipesModule,
    ConfigModule,
    CommonModule,
    ServicesModule,
    ComponentsModule,
    DirectivesModule,
  ],
})
export class PortalModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/portal.module.ts